import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar'
import Footer from '../footer/Footer'
import grey from '../../assets/images/grey.png';
import purple from '../../assets/images/purple.png';
import orange from '../../assets/images/orange.png';
import BackupHook from './BackupHook';
import { useLocation } from 'react-router-dom';
import { baseURLProd } from '../../api';
import { toast, ToastContainer } from 'react-toastify';

const BackupSeats = () => {
    const { toggleModal, showModal, handleConfirmSelection, cancelToggle, cancelModal, modalData, toggleCloseModal,
        isSeatBooked, setIsSeatBooked, handleCancelBooking, cancelCloseToggle
    } = BackupHook()

    const [seatData, setSeatData] = useState('');
    const [seats, setSeats] = useState([]);
    const userId = localStorage.getItem('userId')

    const location = useLocation();
    const { backupData } = location.state || {};
    useEffect(() => {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("backup_skill_id", backupData.data.backup_skill_id)

        fetch(`${baseURLProd}seat-detail`, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data?.status)
                    setSeatData(data.data);
                setSeats(data.seats);
            });
    }, []);

    const getSeatStyle = (isbook) => {
        switch (isbook) {

            case 'reaming book':
                return { background: '#E5EEF6', border: '1px solid #674DEE', color: '#674DEE', image: purple };
            case 'book':
                return { background: '#0cac0c', border: '1px solid #0cac0c', color: 'white', image: purple };
            case 'not book':
                return { background: '#E5EEF6', border: '1px solid #674DEE', color: '#674DEE', image: purple };
            case 'already book':
                return { background: '#FCF0E5', border: '1px solid #F6921E', color: 'F6921E', image: orange };
            default:
                return { background: '#FFFFFF', border: '1px solid #000000', color: '#000000', image: null };
        }
    };
    const handleSeatClick = (seat) => {

        // If the clicked seat is already booked, open the cancellation popup
        if (seat.is_book === 'book') {
            cancelToggle(backupData.data.backup_skill_id, seatData.total_seat, seat.seatno);
            return;
        }

        // Check if any other seat is booked
        const anySeatBooked = seats.some((s) => s.is_book === 'book');

        // If any other seat is booked, prevent selection
        if (anySeatBooked) {
            toast.info('You cannot select another seat as one is already booked.');
            return;
        }

        // If the clicked seat is not booked, proceed with selection
        if (seat.is_book === 'reaming book' || seat.is_book === 'not book') {
            toggleModal(backupData.data.backup_skill_id, seatData.total_seat, seat.seatno);
            setIsSeatBooked(true); // Mark a seat as booked
        }
        if (seat.is_book === 'already book') {
            toast.info('Already booked.');
        }
    };


    return (
        <div>
            <div>
                <Navbar />
                <div className='pt-3 innerBg'>
                    <h1 style={{ color: 'white', fontWeight: '600' }}>Backup Classes
                    </h1>
                </div>
                <div className='py-5 my-3'>
                    <div className='my-4'>
                        <div className='py-4 text-center' style={{ background: 'linear-gradient(90deg, rgba(171, 65, 74, 0) 0%, rgba(171, 65, 74, 0.1) 52%, rgba(171, 65, 74, 0) 100%)' }}>
                            <strong className='mt-4 text-color'>Here’s your Backup Class</strong>
                        </div>
                    </div>
                    <div className='querycard'>
                        <div className='innerhead'>
                            <p className='fw basecolor'>{backupData.data.topics}</p>
                        </div>
                        <div className='my-3'>
                            <div style={{ background: "#A83942", borderRadius: '20px' }} className='py-4'>
                                <div>
                                    <p className='text-center white fw pb-4'>Class Details</p>
                                </div>
                                <div className='row'>
                                    <div className='col ms-5'>
                                        <p className='white fw'>Date/Day</p>
                                        <p className='white fw'>Start Time</p>
                                        <p className='white fw'>Faculty</p>

                                    </div>
                                    <div className='col'>
                                        <p className='white fw'>{backupData.data["date/day"]}</p>
                                        <p className='white fw'>{backupData.data.start_time}</p>
                                        <p className='white fw'>{backupData.data.faculty}</p>

                                    </div>
                                    <div className='col'>
                                        <p className='white fw'>Topic</p>
                                        <p className='white fw'>End Time</p>
                                        <p className='white fw'>Center</p>

                                    </div>
                                    <div className='col'>
                                        <p className='white fw'>{backupData.data.topics}</p>
                                        <p className='white fw'> {backupData.data.end_time}</p>
                                        <p className='white fw'> {backupData.data.center}</p>
                                    </div>
                                </div>
                                {backupData.data.zoom_link !== "" ?
                                    <div className='d-flex'>
                                        <div className=' ms-5'>
                                            <p className='white fw'>Zoom link for live class</p>
                                        </div>
                                        <div className='ms-5'>
                                            <a href={backupData.data.zoom_link} target="_blank" rel="noopener noreferrer" className='white fw' style={{textDecoration:"none"}}>
                                                {backupData.data.zoom_link}
                                            </a>
                                        </div>
                                    </div>
                                    : ''
                                }
                            </div>
                        </div>
                        <div>
                            <p className='basecolor fw text-center py-4'>Book your Seat now !</p>
                        </div>
                        <div>
                            <div className='row seatdiv' >
                                <div className='col' style={{ background: "#F1F1F1", border: "1px solid #828080", borderRadius: "10px" }}>
                                    <div className='d-flex py-2'>
                                        <div>
                                            <img src={grey}></img>
                                        </div>
                                        <div className='ms-4'>
                                            <p className='fw '>Total Seats</p>
                                            <p className='fw'>{seatData.total_seat}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col' style={{ background: "#E5EEF6", border: "1px solid #674DEE", borderRadius: "10px" }}>
                                    <div className='d-flex py-2'>
                                        <div>
                                            <img src={purple}></img>
                                        </div>
                                        <div className='ms-4'>
                                            <p className='fw' style={{ color: "#674DEE" }}>Vacant Seats</p>
                                            <p className='fw' style={{ color: "#674DEE" }}>{seatData.vaccant_seat}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col' style={{ background: "#FCF0E5", border: "1px solid #F6921E", borderRadius: "10px" }}>
                                    <div className='d-flex py-2'>
                                        <div>
                                            <img src={orange}></img>
                                        </div>
                                        <div className='ms-4'>
                                            <p className='fw' style={{ color: "#F6921E" }}>Booked Seats</p>
                                            <p className='fw' style={{ color: "#F6921E" }}>{seatData.booked_seat}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <ToastContainer />
                                <p className='basecolor fw text-center py-4 mt-4'>Classroom Seat !</p>
                            </div>
                            <div>
                                <div className='row seatdiv'>
                                    {seats.map((seat, index) => {
                                        const isbook = seat.is_book;
                                        const { background, border, color, image } = getSeatStyle(isbook);
                                        return (
                                            <div
                                                key={index}
                                                className="col seat"
                                                // className={`col seat ${isSeatBooked && seat.is_book !== 'book' ? 'disabled' : ''}`}
                                                style={{
                                                    background: background,
                                                    border: border,
                                                    borderRadius: "10px",
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => handleSeatClick(seat)}
                                            >
                                                <div className='d-flex py-2'>
                                                    <div>
                                                        <img src={image} alt={`seat-${index}`} />
                                                    </div>
                                                    <div className='ms-4'>
                                                        <p className='fw' style={{ color: color }}>
                                                            {seat.seatno}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {showModal && (
                    <div>
                        <div
                            className="modal-backdrop"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1040,
                            }}
                        ></div>
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                            {/* <div className="modal fade" style={{ display: 'block' }} tabIndex="-1" role="dialog"> */}
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-end">
                                        <h5 className="modal-title"></h5>
                                        <button type="button" className="close" onClick={toggleCloseModal} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center ">
                                        {/* <img src={orange}>
                                        </img> */}
                                        <p className='mb-0'>Please book your seat only if you’re 100% sure of attending the class.</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary loginBtn2"
                                            //  onClick={()=>handleBackupDetails(backup_id)}
                                            onClick={() => {
                                                handleConfirmSelection(
                                                    modalData.user_id,
                                                    modalData.backup_id,
                                                    modalData.no_of_seat,
                                                    modalData.seatno,
                                                );
                                            }}
                                        >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {cancelModal && (
                    <div>
                        <div
                            className="modal-backdrop"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1040,
                            }}
                        ></div>
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                            {/* <div className="modal fade" style={{ display: 'block' }} tabIndex="-1" role="dialog"> */}
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-end">
                                        <h5 className="modal-title"></h5>
                                        <button type="button" className="close" onClick={cancelCloseToggle} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center ">
                                        {/* <img src={orange}>
                                        </img> */}
                                        <p className='mb-0'>Do you want to cancel your backup class?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary loginBtn2"
                                            // onClick={()=>handleBackupDetails(backup_id,)}
                                            onClick={() => {
                                                handleCancelBooking(
                                                    modalData.user_id,
                                                    modalData.backup_id,
                                                    modalData.no_of_seat,
                                                    modalData.seatno,
                                                );
                                            }}
                                        >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
            </div>
        </div>
    )
}

export default BackupSeats
